<template>
  <!-- 页脚组件（Amber Logic 设计） -->
  <footer class="footer">
    <div class="container">
      <!-- 主要内容区 -->
      <div class="footer__content">
        <!-- 公司信息 -->
        <div class="footer__section footer__about">
          <div class="footer__logo">
            <div class="footer__logo-icon">
              <img src="@/static/logo.jpg" alt="米晴科技" class="logo-image" />
            </div>
            <div>
              <div class="footer__logo-text">米晴科技</div>
              <div class="footer__logo-en">Miqing Tech</div>
            </div>
          </div>
          <p class="footer__description">
            专注于智能寄存柜与智能存储解决方案，为 KTV、酒吧、水上乐园、医疗机构、高铁火车站等场景提供专业服务。
          </p>
          <div class="footer__social">
            <div
              v-for="item in socialLinks"
              :key="item.type"
              class="footer__social-item"
              @mouseenter="showQrCode = item.type"
              @mouseleave="showQrCode = null"
            >
              <i :class="item.iconClass">{{ item.text }}</i>
              <transition name="qrcode-fade">
                <div v-if="showQrCode === item.type && item.qrCode" class="qrcode-popup">
                  <img :src="item.qrCode" :alt="item.label" />
                  <p>{{ item.label }}</p>
                </div>
                <div v-else-if="showQrCode === item.type && item.phone" class="phone-popup">
                  <p class="phone-number">{{ item.phone }}</p>
                  <p class="phone-label">{{ item.label }}</p>
                </div>
              </transition>
            </div>
          </div>
        </div>

        <!-- 快速链接 -->
        <div class="footer__section">
          <h4 class="footer__title">产品与方案</h4>
          <ul class="footer__list">
            <li v-for="item in quickLinks" :key="item.path">
              <router-link :to="item.path" class="footer__link">
                {{ item.name }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- 公司导航 -->
        <div class="footer__section">
          <h4 class="footer__title">公司</h4>
          <ul class="footer__list">
            <li v-for="item in companyLinks" :key="item.name">
              <a
                v-if="item.action"
                class="footer__link"
                href="javascript:;"
                @click="handleAction(item.action)"
              >
                {{ item.name }}
              </a>
              <router-link v-else :to="item.path" class="footer__link">
                {{ item.name }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- 联系方式 -->
        <div class="footer__section">
          <h4 class="footer__title">联系我们</h4>
          <ul class="footer__list">
            <li class="footer__contact-item">
              <span class="footer__contact-label">客服电话</span>
              <a href="tel:400-0811-363" class="footer__phone">400-0811-363</a>
            </li>
            <li class="footer__contact-item">
              <span class="footer__contact-label">邮箱</span>
              <a href="mailto:miqingtec2020@163.com" class="footer__email">miqingtec2020@163.com</a>
            </li>
            <li class="footer__contact-item">
              <span class="footer__contact-label">地址</span>
              <span class="footer__address">上海市嘉定区翔江公路1863号洲扬众创园8幢229</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- 底部版权信息 -->
      <div class="footer__bottom">
        <div class="footer__copyright">
          <p>&copy; 2020-{{ currentYear }} 上海市米晴科技有限公司 All Rights Reserved</p>
        </div>
        <div class="footer__icp">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">沪ICP备2025119978号</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { eventBus } from '@/utils/eventBus'

export default {
  name: 'Footer',

  data() {
    return {
      showQrCode: null,
      currentYear: new Date().getFullYear(),
      quickLinks: [
        { name: '产品服务', path: '/products' },
        { name: '场景方案', path: '/solutions' },
        { name: '服务案例', path: '/cases' },
        { name: '合作申请', path: '/apply' }
      ],
      companyLinks: [
        { name: '关于我们', path: '/about' },
        // { name: '加入我们', path: '/about' },
        { name: '隐私政策', action: 'open-privacy-dialog' },
        // { name: 'Cookie设置', action: 'open-privacy-dialog' }
      ],
      socialLinks: [
        {
          type: 'wechat',
          label: '微信服务号',
          text: '微',
          iconClass: 'icon-wechat',
          qrCode: require('@/static/qrcode.jpg')
        },
        {
          type: 'phone',
          label: '客服电话',
          text: '电',
          iconClass: 'icon-phone',
          phone: '400-0811-363'
        }
      ]
    }
  },

  methods: {
    handleAction(action) {
      eventBus.$emit(action)
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: $bg-surface-low;
  color: $text-secondary;
  padding: $spacing-xxxl 0 $spacing-xl;
  border-top: 1px solid $border-color;
  margin-top: auto;

  &__content {
    display: grid;
    grid-template-columns: 1.6fr 1fr 1fr 1.4fr;
    gap: $spacing-xxl;
    margin-bottom: $spacing-xxl;

    @include tablet {
      grid-template-columns: 1fr 1fr;
    }

    @include mobile {
      grid-template-columns: 1fr;
      gap: $spacing-xl;
    }
  }

  &__section {
    @include flex-column;
    gap: $spacing-md;
  }

  // Logo 区域
  &__logo {
    display: flex;
    align-items: center;
    gap: $spacing-sm;
    margin-bottom: $spacing-sm;
  }

  &__logo-icon {
    width: 44px;
    height: 44px;
    border-radius: $border-radius-md;
    overflow: hidden;
    @include flex-center;
    background-color: $bg-white;

    .logo-image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &__logo-text {
    font-size: $font-size-lg;
    font-weight: $font-weight-bold;
    color: $text-primary;
    line-height: 1.2;
  }

  &__logo-en {
    font-size: $font-size-xs;
    font-weight: $font-weight-medium;
    color: $text-tertiary;
    margin-top: 2px;
    letter-spacing: 0.04em;
  }

  &__description {
    font-size: $font-size-sm;
    line-height: $line-height-relaxed;
    color: $text-secondary;
    max-width: 360px;
  }

  // 社交媒体图标
  &__social {
    display: flex;
    gap: $spacing-sm;
    margin-top: $spacing-sm;
  }

  &__social-item {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: $border-radius-md;
    background-color: $bg-white;
    border: 1px solid $border-color;
    @include flex-center;
    transition: all $transition-normal;
    cursor: pointer;

    i {
      font-size: $font-size-sm;
      font-style: normal;
      color: $primary-color;
      font-weight: $font-weight-semibold;
    }

    &:hover {
      background-color: $primary-color;
      border-color: $primary-color;
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba($primary-color, 0.25);

      i {
        color: $on-primary;
      }
    }
  }

  // 二维码弹窗
  .qrcode-popup,
  .phone-popup {
    position: absolute;
    bottom: calc(100% + 12px);
    left: 50%;
    transform: translateX(-50%);
    background: $bg-white;
    padding: $spacing-md;
    border-radius: $border-radius-md;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    z-index: 100;
    min-width: 150px;
    text-align: center;

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border: 6px solid transparent;
      border-top-color: $bg-white;
    }

    img {
      width: 120px;
      height: 120px;
      display: block;
      margin: 0 auto;
      border-radius: $border-radius-sm;
    }

    p {
      margin-top: $spacing-sm;
      font-size: $font-size-xs;
      color: $text-primary;
      font-weight: $font-weight-medium;
      white-space: nowrap;
    }
  }

  // 电话弹窗特殊样式
  .phone-popup {
    min-width: 180px;
    padding: $spacing-lg;

    .phone-number {
      font-size: $font-size-xl;
      font-weight: $font-weight-bold;
      color: $primary-color;
      margin: 0;
      letter-spacing: 1px;
    }

    .phone-label {
      margin-top: $spacing-sm;
      font-size: $font-size-xs;
      color: $text-secondary;
      font-weight: $font-weight-medium;
    }
  }

  // 二维码淡入淡出动画
  .qrcode-fade-enter-active,
  .qrcode-fade-leave-active {
    transition: opacity 0.3s, transform 0.3s;
  }

  .qrcode-fade-enter-from,
  .qrcode-fade-leave-to {
    opacity: 0;
    transform: translateX(-50%) translateY(5px);
  }

  // 标题
  &__title {
    font-size: $font-size-base;
    font-weight: $font-weight-semibold;
    color: $text-primary;
    margin-bottom: $spacing-xs;
  }

  // 链接列表
  &__list {
    @include flex-column;
    gap: $spacing-sm;
  }

  &__link {
    font-size: $font-size-sm;
    color: $text-secondary;
    transition: all $transition-normal;
    display: inline-block;

    &:hover {
      color: $primary-color;
      transform: translateX(2px);
    }
  }

  // 联系信息
  &__contact-item {
    font-size: $font-size-sm;
    color: $text-secondary;
    line-height: $line-height-relaxed;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__contact-label {
    color: $text-tertiary;
    font-size: $font-size-xs;
  }

  &__phone {
    font-weight: $font-weight-bold;
    font-size: $font-size-base;
    color: $primary-color !important;
    letter-spacing: 0.5px;

    &:hover {
      color: $primary-active !important;
    }
  }

  &__email {
    font-weight: $font-weight-medium;
    font-size: $font-size-sm;
    color: $primary-color !important;
    word-break: break-all;
    transition: all $transition-normal;

    &:hover {
      color: $primary-active !important;
    }
  }

  &__address {
    font-size: $font-size-sm;
    color: $text-secondary;
    line-height: $line-height-relaxed;
  }

  // 底部版权
  &__bottom {
    @include flex-between;
    padding-top: $spacing-xl;
    border-top: 1px solid $border-color;

    @include mobile {
      flex-direction: column;
      gap: $spacing-sm;
      text-align: center;
    }
  }

  &__copyright {
    font-size: $font-size-xs;
    color: $text-tertiary;

    p {
      margin: 0;
    }
  }

  &__icp {
    font-size: $font-size-xs;

    a {
      color: $text-tertiary;
      transition: color $transition-normal;

      &:hover {
        color: $primary-color;
      }
    }
  }
}
</style>
